import {
	ApiResponseSuccess,
	approveMobileDevice,
	getDeviceMobileList,
	getMobileDeviceDetail,
	IDeviceMobileDetailResponse,
	reapproveMobileDevice,
	rejectMobileDevice,
	revokeMobileDevice,
	TGetDeviceMobileListResponse,
} from '@/services';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import { formatDeviceMobileList } from './device-mobile.helper';
import { DeviceMobileActions } from './device-mobile.redux';
import {
	IPayloadApproveMobileDeviceRequest,
	IPayloadGetDeviceMobileDetailRequest,
	IPayloadGetDeviceMobileListRequest,
	IPayloadReapproveMobileDeviceRequest,
	IPayloadRejectMobileDeviceRequest,
	IPayloadRevokeMobileDeviceRequest,
} from './device-mobile.type';

export function* getDeviceMobileListSaga(
	action: PayloadAction<IPayloadGetDeviceMobileListRequest>
) {
	const { callback, ...params } = action.payload;

	try {
		const res: ApiResponseSuccess<TGetDeviceMobileListResponse> =
			yield getDeviceMobileList({ ...params });
		const total = res?.data?.total || 0;
		const list = formatDeviceMobileList(res?.data?.content || [], {
			total,
			page: params.page || 1,
			pageSize: params.pageSize || 10,
		});

		yield put(
			DeviceMobileActions.getDeviceMobileListSuccess({
				list,
				totalCount: total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceMobileActions.getDeviceMobileListFailure());
	}
}

export function* getDeviceMobileDetailSaga(
	action: PayloadAction<IPayloadGetDeviceMobileDetailRequest>
) {
	const { deviceId, callback } = action.payload;

	try {
		const res: ApiResponseSuccess<IDeviceMobileDetailResponse> =
			yield getMobileDeviceDetail(deviceId);

		yield put(
			DeviceMobileActions.getDeviceMobileDetailSuccess({
				detail: res?.data,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceMobileActions.getDeviceMobileDetailFailure());
	}
}

export function* approveMobileDeviceSaga(
	action: PayloadAction<IPayloadApproveMobileDeviceRequest>
) {
	const { deviceId, callback } = action.payload;

	try {
		yield approveMobileDevice(deviceId);

		yield put(DeviceMobileActions.approveMobileDeviceSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceMobileActions.approveMobileDeviceFailure());
	}
}

export function* rejectMobileDeviceSaga(
	action: PayloadAction<IPayloadRejectMobileDeviceRequest>
) {
	const { deviceId, rejectReason, callback } = action.payload;

	try {
		yield rejectMobileDevice(deviceId, { rejectReason });

		yield put(DeviceMobileActions.rejectMobileDeviceSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceMobileActions.rejectMobileDeviceFailure());
	}
}

export function* revokeMobileDeviceSaga(
	action: PayloadAction<IPayloadRevokeMobileDeviceRequest>
) {
	const { deviceId, callback } = action.payload;

	try {
		yield revokeMobileDevice(deviceId);

		yield put(DeviceMobileActions.revokeMobileDeviceSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceMobileActions.revokeMobileDeviceFailure());
	}
}

export function* reapproveMobileDeviceSaga(
	action: PayloadAction<IPayloadReapproveMobileDeviceRequest>
) {
	const { deviceId, callback } = action.payload;

	try {
		yield reapproveMobileDevice(deviceId);

		yield put(DeviceMobileActions.reapproveMobileDeviceSuccess());

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceMobileActions.reapproveMobileDeviceFailure());
	}
}
